const DB_KEY = '__aseller_web_realm__';

const readDb = () => {
  try {
    const raw = window.localStorage.getItem(DB_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (_) {
    return {};
  }
};

const writeDb = (db) => {
  try {
    window.localStorage.setItem(DB_KEY, JSON.stringify(db));
  } catch (_) {}
};

const asCollection = (items) => {
  const arr = Array.isArray(items) ? items : [];
  arr.filtered = () => asCollection(arr);
  arr.sorted = () => asCollection(arr);
  arr.snapshot = () => asCollection(arr.slice());
  return arr;
};

class RealmLike {
  constructor() {
    this.db = readDb();
  }

  write(fn) {
    const result = typeof fn === 'function' ? fn() : undefined;
    writeDb(this.db);
    return result;
  }

  _table(name) {
    if (!this.db[name]) this.db[name] = [];
    return this.db[name];
  }

  create(name, value = {}, updateMode) {
    const table = this._table(name);
    const next = { ...value };
    const key = next.id ?? next._id ?? next.code;
    if (updateMode && key !== undefined) {
      const idx = table.findIndex((x) => (x.id ?? x._id ?? x.code) === key);
      if (idx >= 0) {
        table[idx] = { ...table[idx], ...next };
        return table[idx];
      }
    }
    table.push(next);
    return next;
  }

  delete(target) {
    if (Array.isArray(target)) {
      target.length = 0;
      return;
    }
    Object.keys(this.db).forEach((k) => {
      this.db[k] = this.db[k].filter((item) => item !== target);
    });
  }

  objects(name) {
    return asCollection(this._table(name));
  }

  objectForPrimaryKey(name, key) {
    return this._table(name).find((x) => (x.id ?? x._id ?? x.code) === key) || null;
  }

  close() {}
}

const Realm = {
  UpdateMode: { Modified: 'modified', Never: 'never' },
  open: async () => new RealmLike(),
  schemaVersion: async () => 1,
};

export default Realm;
